import InsertLinkIcon from "@mui/icons-material/InsertLink";

const LinkCopyButton = ({ URL }) => {
  return (
    <button
      style={{
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        backgroundColor: "transparent",
        border: "none",
        cursor: "pointer",
        color: "#7A8490",
        padding: "4px",
        borderRadius: "8px",
        transition: "color .12s, background-color .12s",
      }}
      title="링크 복사"
      onClick={() => {
        navigator.clipboard
          .writeText(URL)
          .then(() => {
            alert("URL이 클립보드에 복사되었습니다!");
          })
          .catch((err) => {
            console.error("클립보드 복사 실패: ", err);
          });
      }}
      onMouseEnter={(e) => {
        e.currentTarget.style.color = "#00A396";
        e.currentTarget.style.backgroundColor = "#F4F8F7";
      }}
      onMouseLeave={(e) => {
        e.currentTarget.style.color = "#7A8490";
        e.currentTarget.style.backgroundColor = "transparent";
      }}
    >
      <InsertLinkIcon style={{ fontSize: "20px" }} />
    </button>
  );
};

export default LinkCopyButton;
